import React, { useContext, useState } from "react";
import BlueLoader from "../loader/BlueLoader";
import Loader from "../loader/Loader";
import { addCommas, p2e, removeNonNumeric } from "../../utils/functions";
import axios from "axios";
import { SERVERMODE } from "../../constants/serverMode";
import {
  serverErrorMessage,
  SERVERMESSAGE,
} from "../../constants/serverMessage";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import globalContext from "../../Contexts/GlobalContext";
import useRequestHeader from "../../hooks/useRequestHeader";
import { handleServerMode } from "../../utils/handleServer";
import ColoredLoader from "../coloredLoader/ColoredLoader";
export default function ViolationDetailingItems({
  amount,
  billID,
  paymentID,
  time,
  delivery,
  location,
  type,
  isOneOfViolationListPayLoading,
  setIsOneOfViolationListPayLoading,
}) {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  const [isLoadingPayViolation, setIsLoadingPayViolation] = useState(false);
  const payViolation = () => {
    if (!isLoadingPayViolation && !isOneOfViolationListPayLoading) {
      setIsLoadingPayViolation(true);
      setIsOneOfViolationListPayLoading(true);
      const config = {
        headers: requestHeader,
      };
      const reqBody = {};
      reqBody.billID = billID;
      reqBody.payID = paymentID;
      axios
        .post(`${BASE_URL}/inquiries/violation/payAndBill`, reqBody, config)
        .then((res) => {
          var responseMode = res?.data?.Mode;
          var responseMessage = res?.data?.Message;
          switch (responseMode) {
            case SERVERMODE.REQUEST_OK: {
              if (res?.data?.Data?.PaymentLink) {
                var paymentUrl = res?.data?.Data?.PaymentLink;
                window.open(paymentUrl, "_self");
              }
              break;
            }
            case SERVERMODE.REQUEST_WRONG: {
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(SERVERMESSAGE.WRONG_PAY_AND_BILL_ID);
              break;
            }
            case SERVERMODE.REQUEST_ERROR: {
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(serverErrorMessage());
              break;
            }
            case SERVERMODE.SERVICE_NOT_ACTIVE: {
              contextData.setIsToastOpen(true);
              contextData.setToastMessage(SERVERMESSAGE.SERVICE_NOT_ACTIVE);
              navigate("/payEst", { replace: true });
              break;
            }
            default: {
              handleServerMode(
                responseMode,
                responseMessage,
                contextData,
                cookies,
                removeCookies,
                navigate
              );
            }
          }
          setIsLoadingPayViolation(false);
          setIsOneOfViolationListPayLoading(false);
        })
        .catch((err) => {
          contextData.setIsToastOpen(true);
          contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
          setIsLoadingPayViolation(false);
          setIsOneOfViolationListPayLoading(false);
        });
    }
  };
  return (
    <div className="w-full rounded-[1.8vw] border-color-primary-D border-[1px] bg-[#10242b] px-[16px] py-[4vw] mt-[4vw]">
      <div className="w-full  font-font_primary_A text-color-primary-A font-bold text-[3.5vw]">
        <span>{delivery}</span>
        <span className="mx-[2vw]">-</span>
        <span>{location}</span>
      </div>
      <div className="w-full  font-font_primary_A text-color-primary-C3 text-[3.2vw] mt-[2vw]">
        <span>شرح تخلف:</span>
        <span className="mr-[1vw]">{type}</span>
      </div>
      <div className="w-full h-[1px]  bg-color-primary-C3 mt-[2vw]"></div>

      <div className="w-full flex items-center justify-between font-font_primary_A text-color-primary-C3 font-semibold text-[3vw] mt-[2vw]">
        <span>زمان ثبت خلافی</span>
        <div className="flex items-center justify-center gap-x-[1vw]">
          <span>{time?.split(",")[1]}</span>
          <span>|</span>
          <span>{time?.split(",")[0]}</span>
        </div>
      </div>
      <div className="w-full flex items-center justify-between font-font_primary_A text-color-primary-C3 font-semibold text-[3vw] mt-[2vw]">
        <span>مبلغ خلافی</span>
        <div className="flex items-center justify-center gap-x-[1vw]">
          <span> {addCommas(removeNonNumeric(p2e(amount)))}</span>

          <span>ریال</span>
        </div>
      </div>
      <div className="w-full h-[1px]  bg-color-primary-C3 mt-[2vw]"></div>
      <button
        className="w-full h-[7.5vw] flex items-center justify-center  bg-color-success-2 text-color-success-1 text-[3vw] font-font_primary_A font-bold  rounded-[0.9vw] mt-[2vw]"
        onClick={payViolation}
      >
        {isLoadingPayViolation ? (
          <ColoredLoader size={25} color="#2B6103" />
        ) : (
          "پرداخت"
        )}
      </button>
    </div>
  );
}
